<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/12Gor6U/tc-custom/9781942934325.jpg?1705025875775" alt="This image is the cover for the book Mary & Me"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mary & Me
      </h1>
      <p class="bookDescription body article font2">
        <b>“A powerful testament to the beauty of friendship as told through decades of letter writing . . . disarmingly personal.” —Heather Gudenkauf, <i>New York Times–bestselling </i>author of <i>This is How I Lied</i></b><br/><br/><i>Mary &amp; Me: A Lasting Link Through Ink</i> explores a thirty-year friendship between two women: one who had never learned to cultivate female friendships, and the other who had managed to gather and maintain a large group of friends throughout her adult life. The fact that thousands of handwritten letters between them tethered these two together is just part of the intriguing story.<br/><br/>Coauthors Mary Potter Kenyon—author of <i>Refined by Fire, Coupon Crazy</i>, and <i>Chemo-Therapist</i>—and Mary Jedlicka Humston share an unforgettable friendship that will inspire you to pick up your pen and begin writing “Dear . . .”<br/><br/>“Offers rich wisdom about the art of friendship and the beauty of commitment.” —Shelly Beach, Christy Award-winning author of <i>Ambushed by Grace</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mary Potter Kenyon, Mary Jedlicka Humston
      </h2>
      
      <p class="authorDescription body article">Mary Potter Kenyon graduated from the University of Northern Iowa with a BA in Psychology and is the Director of the Winthrop Iowa Public Library. She is widely published in magazines, newspapers, and anthologies. She is a popular speaker and workshop presenter for women's groups, libraries, community colleges and writer's conferences. Her public speaking repertoire includes the topics of caregiving, couponing, writing, utilizing your creativity in your everyday life, and finding hope and healing in grief. This is Mary's fourth book published by Familius. She is the author of "Coupon Crazy: The Science, the Savings, and the Stories Behind America's Extreme Obsession," "Chemo-Therapist: How Cancer Cured a Marriage," and "Refined By Fire: A Journey of Grief and Grace." She lives in Manchester, Iowa. Check out her website at marypotterkenyon.com  Mary Jedlicka Humston, a former high school teacher, graduated from the University of Northern Iowa with a BA in English Education. She has had over 150 poems and essays published at the local and national level in newspapers, magazines, books, and online. One of her poems was chosen to be projected on the Krakow City of Literature UNESCO Poems on the Wall in 2014. Mary has presented programs on cancer, dealing with chronic illness, prayer, writing, and the Little Free Library movement. She is a member of National League of American Pen Women and The University Club Writers of Iowa City. She lives in Iowa City with her husband Jim.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Familius
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16c81564